// Document keys are `org/<orgId>/<uuid>/<userSub>_<name>`; legacy keys are just
// `<userSub>_<name>`. Display code works on the last segment either way.
export function fileBaseName(filename: string | null | undefined): string {
  return (filename || '').split('/').pop() || '';
}
